export const MAP_ZOOM_LEVEL = 12;
export const COORDS = [40.7591703, -74.0394429];
